import React, { useEffect, useState } from 'react';
interface SquaresProps {
  className?: string;
  /** Number of squares to light up at any time */
  lit?: number;
  /** Cell size in pixels */
  cellSize?: number;
}
export function Squares({
  className = '',
  lit = 12,
  cellSize = 64
}: SquaresProps) {
  const [activeCells, setActiveCells] = useState<string[]>([]);
  useEffect(() => {
    let mounted = true;
    const tick = () => {
      if (!mounted) return;
      const newCells: string[] = [];
      for (let i = 0; i < lit; i++) {
        const r = Math.floor(Math.random() * 30);
        const c = Math.floor(Math.random() * 30);
        newCells.push(`${r}-${c}`);
      }
      setActiveCells(newCells);
    };
    tick();
    const interval = setInterval(tick, 1200);
    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, [lit]);
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-252">
      {/* Grid lines */}
      <div className="absolute inset-0" style={{
      backgroundImage: 'linear-gradient(rgba(26,143,212,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(26,143,212,0.06) 1px, transparent 1px)',
      backgroundSize: `${cellSize}px ${cellSize}px`,
      maskImage: 'radial-gradient(ellipse at center, black 30%, transparent 80%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 30%, transparent 80%)'
    }} data-id="element-253" />

      {/* Lit cells */}
      <div className="absolute inset-0" data-id="element-254">
        {activeCells.map(id => {
        const [r, c] = id.split('-').map(Number);
        return <div key={id + Math.random()} className="absolute transition-opacity duration-1000" style={{
          width: cellSize,
          height: cellSize,
          left: c * cellSize,
          top: r * cellSize,
          background: 'radial-gradient(circle, rgba(26,143,212,0.3) 0%, transparent 70%)',
          opacity: 0.8,
          animation: 'square-fade 1.2s ease-in-out'
        }} data-id="element-255" />;
      })}
      </div>
    </div>;
}